export default function searchOverlayUi() {
  const searchModal = document.querySelector("#search-modal");
  if (!searchModal) return;

  const searchModalBody = searchModal.querySelector(".modal-body");
  const searchModalInput = document.querySelector("#search-modal-input");
  const searchModalInputTrigger = document.querySelector("#search-modal-button");
  const searchResultsTitle = document.querySelector(".search-result-title-query");
  const searchResultsCount = document.querySelector(".search-results-count-number");

  const searchInput = document.querySelector('#search-products-input');
  const searchInputTrigger = document.querySelector("#search-products-button");

  if (!searchInput || !searchModalInput || !searchInputTrigger) return

  const setLoading = function (bool) {
    searchModalBody.classList.toggle('loading', bool)
  }

  const makeQuery = function (query) {
    const siteUrl = window.SD_SITE_URL ?? 'https://www.sushidaily.com/';
    let culture = window.SD_CULTURE_INFO.urlLanguageSegment;

    if (!culture)
      culture = 'gb-en';

    return fetch(`${siteUrl}umbraco/api/productsapi/names?culture=${culture}&name=${query}`, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
    })
      .then((res) => {
        return res.json()
      })
  }

  const hideShowProducts = function (products) {
    let visibleCount = 0

    //  show all products
    if (!products || products.length === 0) {
      const cards = document.querySelectorAll(`.search-result-category-items .product-grid-item`);
      cards.forEach((product) => {
        product.classList.toggle('hidden', true);
      })
    }

    // hide or show products base on api response
    products.forEach(({ Id, Visible }) => {
      const product = document.querySelector(`.search-result-category-items [data-id='${Id}']`);
      if (!product) return;

      visibleCount += Visible ? 1 : 0

      product.classList.toggle('hidden', !Visible)
    })

    // hide or show empty categories
    const categoriesEl = document.querySelectorAll('.search-result-category');
    if (categoriesEl && categoriesEl.length > 0) {
      categoriesEl.forEach((categoryEl)=> {
        const categoriesItems = categoryEl.querySelector('.search-result-category-items');
        const visibleChildren = [...categoriesItems.children].filter((productEl)=> !productEl.classList.contains('hidden'))

        categoryEl.classList.toggle('hidden', visibleChildren.length === 0)
      })
    }

    // update visual count
    searchResultsCount.innerHTML = visibleCount
  }

  const searchQuery = async function () {
    setLoading(true)
    searchResultsTitle.innerHTML = searchModalInput.value

    makeQuery(searchModalInput.value).then((data) => {
      hideShowProducts(data.results)
      setLoading(false)
    }).catch((err) => {
      setLoading(false)
      console.error(err)
    })
  }

  const showSearchOverlay = (e) => {
    if (e) e.preventDefault();
    window.SD_OpenModal(searchModal)

    searchModalInput.value = searchInput.value
    searchModalInput.focus()
  }

  searchInput.addEventListener('keydown', (e) => {
    const isEnter = e.keyCode === 13
    if (isEnter) {
      searchInput.blur() // useful for mobile to close keyboard on search
      showSearchOverlay()
      searchQuery()
    }
  })

  searchInputTrigger.addEventListener('click', () => {
    showSearchOverlay()
    searchQuery()
    searchInput.blur()
  })

  searchModalInput.addEventListener('keydown', (e) => {
    const isEnter = e.keyCode === 13
    if (isEnter) {
      searchQuery()
      searchModalInput.blur();
    }
  })

  searchModalInputTrigger.addEventListener('click', () => {
    searchQuery()
    searchModalInput.blur();
  })
}